import React from 'react'
import { IonButton } from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import { IPatientSearchState } from '../../features/patientSearch/store/patientSearch.types'
import { getPatientSearchState } from '../../features/patientSearch/selectors'
import { useTranslation } from 'react-i18next'
import { newPtClick } from '../../utilities/patientSearch.util'
import { setIsSearchImport } from '../../features/patientSearch/store/patientSearch.actions'

const NewPatientButton = () => {
  const dispatch = useDispatch()
  const { t } = useTranslation()
  const patientSearchState: IPatientSearchState = useSelector(getPatientSearchState)
  const { showImportDataConfirmationAlert } = patientSearchState

  const handleNewPtClick = () => {
    dispatch(setIsSearchImport(true))
    newPtClick(dispatch, showImportDataConfirmationAlert, t, patientSearchState)
  }

  return (
    <IonButton
      className='ion-float-right'
      color='primary'
      data-testid='NewPatient'
      fill='clear'
      onClick={handleNewPtClick}>
      {t('patientSearch.newPatient')}
    </IonButton>
  )
}

export default NewPatientButton
